import React from 'react';
import Carousel from 'react-multi-carousel';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { Grid, Paper } from '@mui/material';
import 'react-multi-carousel/lib/styles.css';
import './SpectrumMixerChannelSettingsCarousel.css';

import SpectrumMixerChannelSettingsItem, { MixerChannel } from './SpectrumMixerChannelSettingsItem';

const responsive = {
    desktop: {
        breakpoint: { max: 9999, min: 901 },
        items: 2,
        partialVisibilityGutter: 20
    },
    tablet: {
        breakpoint: { max: 900, min: 601 },
        items: 1,
        partialVisibilityGutter: 20
    },
    mobile: {
        breakpoint: { max: 600, min: 0 },
        items: 1,
        partialVisibilityGutter: 20
    }
};

interface SpectrumMixerChannelSettingsCarouselProps {
    onSliderChange: (channelId: string, value: number) => void;
    onIntensityChange: (channelId: string, value: number) => void;
}

const SpectrumMixerChannelSettingsCarousel = ({ onSliderChange, onIntensityChange }: SpectrumMixerChannelSettingsCarouselProps) => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();
    const lightChannels = formData.lightChannels as MixerChannel[];

    const hideDetailedIntensityPopper = () => {
        if (formData.openedDetailedIntensityPopperId) {
            pageActions.formData.updateFormItem({ openedDetailedIntensityPopperId: null });
        }
    };

    // onclick preventDefault: carousel submits the page form on dot click, this event preventDefault call prevents it... :|
    return (
        <Grid item xs={12} sx={{ textAlign: 'center' }} onClick={(e) => e.preventDefault()}>
            <Carousel
                swipeable={false}
                draggable={false}
                showDots={true}
                infinite={true}
                transitionDuration={300}
                responsive={responsive}
                containerClass="carousel-container"
                renderButtonGroupOutside={false}
                beforeChange={hideDetailedIntensityPopper}
            >
                {lightChannels.map((channel) => {
                    if (!channel.spectrogram || channel.intensityPercent === undefined) {
                        return null;
                    }

                    return (
                        <Paper
                            key={channel.id}
                            elevation={3}
                            style={{ margin: '10px', padding: '20px', marginBottom: '10px', display: 'flex', alignItems: 'stretch' }}
                        >
                            <Grid container spacing={2} item>
                                <SpectrumMixerChannelSettingsItem
                                    channel={channel}
                                    formData={formData}
                                    onIntensityChange={onIntensityChange}
                                    onSliderChange={onSliderChange}
                                />
                            </Grid>
                        </Paper>
                    );
                })}
            </Carousel>
        </Grid>
    );
};

export default React.memo(SpectrumMixerChannelSettingsCarousel);
